/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import PropTypes from "prop-types";

function CheckList_TwoColumns({ titlesDescriptionsObj }) {
  return (
    <Grid container>
      {Object.entries(titlesDescriptionsObj).map(([title, description], index) => (
        <Grid item xs={12} lg={6} key={index}>
          <MKBox display="flex" alignItems="center" pr={5} py={2}>
            <MKBox color="primary">
              <Icon fontSize="small">done_outline</Icon>
            </MKBox>
            <MKBox display="flex" flexDirection="column" textAlign="justify">
              <MKBox>
                <MKTypography variant="body1" color="text" pl={2}>
                  {title}
                </MKTypography>
              </MKBox>
              <MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  {description}
                </MKTypography>
              </MKBox>
            </MKBox>
          </MKBox>
        </Grid>
      ))}
    </Grid>
  );
}

CheckList_TwoColumns.propTypes = {
  titlesDescriptionsObj: PropTypes.object.isRequired,
};

export default CheckList_TwoColumns;
